import { render, staticRenderFns } from "./SPIFHeader.vue?vue&type=template&id=78d40254"
import script from "./SPIFHeader.vue?vue&type=script&lang=js"
export * from "./SPIFHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports